'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  Helper methods concerning promises that are based on Axios
*/

/*
  Allow promise to be cancellable.

  @return Object
*/
var cancellablePromise = exports.cancellablePromise = function cancellablePromise(promise) {
  var cancelled = false;
  var result = void 0;

  return {
    promise: new Promise(function (resolve, reject) {
      return promise.then(function (val) {
        result = cancelled ? reject(new Error({ error: 'Request Cancelled' })) : resolve(val.data);
        return result;
      }).catch(function (err) {
        result = cancelled ? reject(new Error({ error: 'Request Cancelled' })) : reject(err);
        return result;
      });
    }),
    cancel: function cancel() {
      cancelled = true;
    }
  };
};


// WEBPACK FOOTER //
// ./submodules/soompi-js/dist/node/promise.js